module.exports = "/_next/static/images/CollectImage@2x-e730d2c248ce39984dbdf91d2ce01662.png";